import { FC } from 'react';

import { ICartConfirmation } from './types';

export const CartConfirmation: FC<React.PropsWithChildren<ICartConfirmation>> = () => null;
